import $ from "jquery";

export class Donation {
  constructor() {
    $('.js-set-donation-amount')
      .on('click', (e) => this.setDonationAmount(e));
  }

  setDonationAmount(e) {
    let amount = $(e.currentTarget)
      .data('amount');
    $('#js-donation_amount-input')
      .val(amount);
  }
}
